import { defineStore } from 'pinia';
import { ref } from 'vue';

import type { MergedFacet } from '@/components/search-fact-finder-fi/mergeFacets';
import { useFischer } from '@/composables/fischerPlugin';
import type { CatalogFacet } from '@/generated/graphql';

export const useProductFamilyStore = defineStore('product-family', () => {
  const fischer = useFischer();

  // State
  const headFacets = ref<MergedFacet[]>([]);
  const listFacets = ref<MergedFacet[]>([]);
  const activeFacets = ref<MergedFacet[]>([]);
  const loading = ref<boolean>(true);
  const totalHits = ref<number>(0);
  const familyProducts = ref<any>([]);

  // Actions
  const setFamilyFacets = (facets: any, catalogData?: any) => {
    if (catalogData && fischer.isProductSeriesEnabled()) {
      headFacets.value = [];
      catalogData.DefiningAttributes?.forEach((facet: CatalogFacet) => {
        const foundFacet = facets.find(
          (factFinderFacet: any) => factFinderFacet.name === facet.FilterId,
        );
        if (foundFacet) {
          headFacets.value.push(foundFacet);
        }
      });

      listFacets.value = [];
      catalogData.FilterAttributes?.forEach((facet: CatalogFacet) => {
        const foundFacet = facets.find(
          (factFinderFacet: any) => factFinderFacet.name === facet.FilterId,
        );
        if (foundFacet && foundFacet.elements?.length > 1) {
          listFacets.value.push(foundFacet);
        }
      });
    } else {
      headFacets.value = facets.slice(0, 3);
      listFacets.value = facets;
    }
  };

  return {
    headFacets,
    listFacets,
    activeFacets,
    loading,
    totalHits,
    familyProducts,
    setFamilyFacets,
  };
});
